import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { withSnackbar } from 'notistack';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom';
import SetColors from '../../../components/Public/Homepage/HomepageSetupDialog/SetColors';
import railsContextDuck from '../../../redux/modules/railsContextDuck';
import organizationDuck from '../../../redux/modules/organizationDuck';
import handleServerError from '../../../lib/functions/handleServerError';
import { CircularLoading } from '../../../lib/components/Loading';
import PreviewToggle from './PreviewToggle';

const mapStateToProps = store => {
  const { $$railsContextStore, $$organizationStore } = store;
  return {
    canEditDesign: $$organizationStore.getIn([
      '$$organization',
      'can_edit_design',
    ]),
    isPreviewing: railsContextDuck.selectors.isPreviewingWebsite(
      $$railsContextStore
    ),
    primaryColor: organizationDuck.selectors.primaryColor($$organizationStore),
  };
};

const styles = {
  roboto: {
    fontFamily: 'Roboto',
    color: '#3e3e3e',
  },
};

class PreviewToggleOld extends Component {
  constructor(props, context) {
    super(props, context);

    this.railsContextActions = bindActionCreators(
      railsContextDuck.creators,
      this.props.dispatch
    );
    this.organizationActions = bindActionCreators(
      organizationDuck.creators,
      this.props.dispatch
    );

    this.state = {
      editBackgroundDialogOpen: false,
      editMainColorDialogOpen: false,
      submitting: false,
      initialPrimaryColor: props.primaryColor,
      editDesignDialogOpen: false,
      showSpinner: false,
    };
  }

  handleBackgroundDone = () => {
    this.setState({ editBackgroundDialogOpen: false });
  };

  handleCancelMainColor = () => {
    if (this.state.submitting) return;
    this.organizationActions.modifyColor(true, this.state.initialPrimaryColor);
    this.setState({ editMainColorDialogOpen: false });
  };

  handleOpenBackground = () => {
    this.setState({ editBackgroundDialogOpen: true });
  };

  handleOpenMainColor = () => {
    this.setState({
      initialPrimaryColor: this.props.primaryColor,
      editMainColorDialogOpen: true,
      editDesignDialogOpen: false,
    });
  };

  handleSaveColor = () => {
    if (this.state.submitting) return;
    this.setState({ submitting: true });
    const { primaryColor, enqueueSnackbar } = this.props;
    const params = { primary_color: primaryColor };
    this.organizationActions
      .updateOrganization(params)
      .then(() =>
        this.setState({
          submitting: false,
          editMainColorDialogOpen: false,
        })
      )
      .catch(error => {
        this.setState({
          submitting: false,
          editMainColorDialogOpen: false,
        });
        handleServerError(error, [], enqueueSnackbar);
      });
  };

  renderEditMainColorDialog() {
    const { primaryColor } = this.props;
    return (
      <Dialog
        open={this.state.editMainColorDialogOpen}
        onClose={this.handleCancelMainColor}
        PaperProps={{ style: { margin: 24 } }}
      >
        <DialogTitle style={{ textAlign: 'center' }}>
          Edit Main Color
        </DialogTitle>
        <div style={{ padding: '0 16px' }}>
          <SetColors
            onChangeComplete={hex =>
              this.organizationActions.modifyColor(true, hex)
            }
            color={primaryColor}
          />
        </div>
        <DialogActions>
          <Button
            style={{ color: '#9e9e9e' }}
            onClick={this.handleCancelMainColor}
          >
            Cancel
          </Button>
          <Button onClick={this.handleSaveColor} style={{ color: '#424242' }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderToggleDesktop() {
    const { isPreviewing, canEditDesign } = this.props;
    return (
      <div style={{ position: 'fixed', top: 80, right: 50, zIndex: 1299 }}>
        <PreviewToggle />
        {!isPreviewing && canEditDesign && window.location.pathname === '/' && (
          <React.Fragment>
            <div style={{ marginTop: 16, textAlign: 'center' }}>
              <Button variant="contained" onClick={this.handleOpenMainColor}>
                Edit Main Color
              </Button>
            </div>
            {/* <div style={{ marginTop: 16, textAlign: 'center' }}>
              <Button variant="contained" as="a" href="/admin/settings">
                Invite Admins
              </Button>
            </div> */}
          </React.Fragment>
        )}
      </div>
    );
  }

  renderSpinner() {
    return this.state.showSpinner && <CircularLoading />;
  }

  render() {
    return (
      <div>
        <Hidden smDown>{this.renderToggleDesktop()}</Hidden>
        {this.renderEditMainColorDialog()}
        {this.renderSpinner()}
      </div>
    );
  }
}

PreviewToggleOld.propTypes = {
  canEditDesign: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  enqueueSnackbar: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  primaryColor: PropTypes.string,

  isPreviewing: PropTypes.bool,
};
PreviewToggleOld.defaultProps = {
  homepage: false,
  isPreviewing: false,
  primaryColor: '',
};

export default connect(mapStateToProps)(
  withStyles(styles)(withSnackbar(withRouter(PreviewToggleOld)))
);
